import { render, staticRenderFns } from "./GlassyCard.vue?vue&type=template&id=197aff3e&scoped=true"
import script from "./GlassyCard.vue?vue&type=script&lang=js"
export * from "./GlassyCard.vue?vue&type=script&lang=js"
import style0 from "./GlassyCard.vue?vue&type=style&index=0&id=197aff3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197aff3e",
  null
  
)

export default component.exports